__turbopack_context__.v({
  "row": "InvitableCompanyList-module-scss-module__244bkG__row",
});
